<template>
  <div id="activity-dialog" class="custom-modal">
    <div class="modal-body"></div>
    <div>
      <HolaconLottieNoData
        class="w-100"
        key="create-loading"
        :source="'holacon-notification-lottie'"
        :title="$t('notifications')"
        @btnAdd="
          false
        "
        @btnRefresh="false"
        :buttonAdd="false"
        :buttonRefresh="false"
        :loading="loading"
      />
    </div>
    <div class="modal-footer" slot="footer">
      <div class="left-buttons">
        <el-button @click="$emit('closeDialog')">{{ $t("event.buttons.close") }}</el-button>
        <!-- <el-popconfirm @confirm="deleteItem" :confirmButtonText="$t('event.variables.yes')" :cancelButtonText="$t('event.buttons.cancel')" icon="el-icon-info" iconColor="red" :title="$t('event.textbox.toDelete')">
          <el-button slot="reference" type="danger" icon="fas fa-trash"> Sil</el-button>
        </el-popconfirm> -->
      </div>
      <div class="right-buttons">
        <!-- <el-button type="primary" @click="{}">Kaydet</el-button> -->
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import PageCountInfo from "../../components/PageCountInfo";
import $ from "jquery";
export default {
  metaInfo: {
    title: "Activity"
  },
  components: { PageCountInfo },
  name: "UsageActivity",
  data() {
    return {
      code: null,
      loading: false,
      colors: [
        { color: "#54f542", percentage: 20 },
        { color: "#1989fa", percentage: 40 },
        { color: "#5cb87a", percentage: 60 },
        { color: "#e6a23c", percentage: 80 },
        { color: "#f56c6c", percentage: 100 }
      ],

      limits: [
        {
          percentage: 89,
          total: 1500,
          left: 185,
          title: this.$t("partRight")
        },
        {
          percentage: 75,
          total: 5,
          left: 3,
          title: this.$t("surveyUsage")
        },
        {
          percentage: 100,
          total: 3,
          left: 0,
          title: this.$t("liveVotingUsage")
        }
      ],
      modalVisible: false,
      updateForm: null,
      isFilterEnabled: false,
      timeout: null
    };
  },
  methods: {
    applyCouponCode() {
      axios.post("payment/applycouponcode", { code: this.code }).then(res => {
        if (res.data.alert.hasError) {
          this.$message.error(res.data.alert.message);
        } else {
          this.$message.success(res.data.alert.message);
          this.$store.dispatch("getUser");
          this.code = null;
        }
      });
    },
    itemUpdated(item) {
      var index = this.$store.state.usages.items.findIndex(k => k.id == item.id);
      if (index != -1) {
        this.$store.state.usages.items.splice(index, 1, item);
      }
    },
    itemAdded(item) {
      this.$store.dispatch("getUsages");
    },
    handleSizeChange(take) {
      this.$store.commit("setUsageTake", take);
    },
    handleCurrentChange(page) {
      $("html, body").animate({ scrollTop: 0 }, 350);
      this.$store.commit("setUsagePage", page);
    },
    deleteItem(index) {
      this.$store.dispatch("deleteUsage", { index, context: this });
    },
    statusChanged(value, index) {
      this.$store.dispatch("toggleUsage", { index, value });
    },
    handleSelectionChange(items) {
      this.$store.commit("setSelectedUsages", items);
    },
    tableRowClassName({ row, rowIndex }) {
      if (row.isActive) {
        return "row-active";
      }
      return "row-passive";
    }
  },
  mounted() {
    this.$store.dispatch("getUsages");
  },
  created() {},
  computed: {
    skip() {
      return (this.$store.state.usages.filter.page - 1) * this.$store.state.usages.filter.take;
    },
    take() {
      return this.skip + this.$store.state.usages.items.length;
    }
  },
  watch: {
    "$store.state.usages.filter.searchTerm": function() {
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        this.$store.dispatch("getUsages");
      }, 500);
    }
  }
};
</script>
<style scoped>
.search-input {
  box-shadow: 0 0 8px rgb(0 0 0 / 16%) !important;
}
.search-button {
  background-color: rgb(38, 142, 166);
  color: white;
  box-shadow: 0 0 8px rgb(0 0 0 / 16%) !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/event/UsageActivity.vue